el.DotNavigationView = function ($, dotNavElement, dotCount) {
  var dotNavigationView = {};
  var dots;
  var currentIndex = 0;
  var isHovering = false;
  var autoNavigateTimer;

  dotNavigationView.init = function () {
    dotNavigationView.view = dotNavElement;

    var dotNavTemplate = $("#dot-navigation-template").html();
    dotNavTemplate = _.template(dotNavTemplate);

    var dotNavHtml = dotNavTemplate({ dotCount: dotCount });
    dotNavElement.html(dotNavHtml);

    dots = dotNavigationView.view.find(".dot");

    wireEvents();
  };

  function wireEvents() {
    dotNavigationView.view.delegate(".dot", "click", function () {
      var index = $(this).index();
      dotNavigationView.setSelectedIndex(index);
    });

    dotNavigationView.view.mouseenter(function () {
      isHovering = true;
    });

    dotNavigationView.view.mouseleave(function () {
      clearTimeout(autoNavigateTimer);
      autoNavigateTimer = setTimeout(autoNavigate, 6000);
      isHovering = false;
    });

    autoNavigateTimer = setTimeout(autoNavigate, 3000);
  }

  function autoNavigate() {
    if (isHovering) {
      return;
    }
    var nextIndex = (currentIndex + 1) % dots.length;
    dotNavigationView.setSelectedIndex(nextIndex);

    setTimeout(autoNavigate, 3000);
  }

  var onSelectionChangeCallback = function () {};
  dotNavigationView.onSelectionChange = function (callback) {
    onSelectionChangeCallback = callback;
  };

  dotNavigationView.setSelectedIndex = function (index) {
    var dot = $(dots.get(index));
    dots.removeClass("selected");
    if (dot) {
      currentIndex = index;
      dot.toggleClass("selected");
      onSelectionChangeCallback(currentIndex);
    }
  };

  return dotNavigationView;
};
